const getTeamColor = (counter: number) => {
  // Brand colors
  const brandColors = [
    '#F36DB7', // Pink
    '#FFB100', // Yellow
    '#65CBCC', // Blue
    '#FF5A01', // Orange
    '#28CC24', // Green
  ];

  // Color variations with similar brightness but different hues
  const colorVariations = [
    '#B76DF3', // Purple (variant of Pink)
    '#00B1FF', // Sky Blue (variant of Yellow)
    '#65CC9B', // Teal (variant of Blue)
    '#FF017A', // Magenta (variant of Orange)
    '#7ACC28', // Lime (variant of Green)
  ];

  const allColors = [...brandColors, ...colorVariations];
  const index = counter % allColors.length;
  return allColors[index] ?? '';
};

export default getTeamColor;
